<template>
    <section class="page-main__section ">
        <!-- Section background -->
        <div class="section-bg-wrapper">
            <!-- You can set several background images by inline: above and under the content; '.section-bg' class means that the background is under the content -->
            <div class="section-bg" ></div>
            {{bgimg}}
            <!-- Set the inline background for the section like below;  '.section-bg_over' class means that the background is above the content -->
            <div class="section-bg section-bg_over" v-if="bgimg" :style="{'background-image': 'url('+media +'sliders/'+ bgimg +')'}"></div>
            <div class="section-bg section-bg_over" v-else :style="{'background-image':'url(' + require('../assets/content/movies-bg-over.png')+')'}"></div>
        </div>
        <!-- /Section background -->
        <!-- Section content -->
        <div class="content-wrapper">
            <div class="section-heading-wrapper">
                <div class="content-wrapper" id="movies">
                    <h2>{{meta.title}}</h2>
                    <router-link :to="{ name: meta.route, params: { category : meta.categories[0].props } }">{{$t('seeAll')}}</router-link>
                </div>
            </div>
            <div v-if="preloader && slideItems && slideItems.length > 0" class="top-video video-swiper">
                <swiper :options="swiperOption"
                        @slideChange="slideEvent"
                        ref="homePageSwiper">
                    <!-- slides -->
                    <swiper-slide v-for="slide in slideItems" :key="slide.id">
                        <div class="teaser">
                            <router-link :to="{ name : 'movie-info', params: { id : slide.id } }">
                                <img :data-src="media + 'sliders/' + slide.image" src="../assets/images/preloader1228x492.gif" class="swiper-lazy" width="1228" height="492" :alt="slide.title">
                                <img :data-src="media + 'sliders/' +  slide.mobileImage" src="../assets/images/preloader350x534.gif" class="swiper-lazy mob" width="350" height="534" :alt="slide.title">
                            </router-link>

                            <div class="content-item__info">
                                <div class="content-item__title" style="text-shadow: rgb(0, 0, 0) 4px 2px 8px;"><h3>{{slide.title}}</h3></div>
                                <div class="content-lang-wrapper">
                                    <div class="content-item__lang"><i class="svg-inline headphones-icon"></i><span style="text-shadow: rgb(0, 0, 0) 4px 2px 8px;">{{slide.lang}}</span></div>
                                    <div class="content-item__sub" v-if="slide.subtitle_lang"><i class="svg-inline sub-icon"></i><span style="text-shadow: rgb(0, 0, 0) 4px 2px 8px;">{{slide.subtitle_lang}}</span></div>
                                </div>
                                <div class="content-item__platforms"><i class="svg-inline plane-icon"></i><span style="text-shadow: rgb(0, 0, 0) 4px 2px 8px;">{{$t('avaiable')}}:  {{slide.airplane}}</span></div>
                            </div>
                        </div>
                    </swiper-slide>

                </swiper>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </div>

            <ul v-if="items.length > 0" class="items-list">
                <li v-for="movie in items" :key="movie.id">
                    <div class="teaser">
                        <router-link :to="{ name : 'movie-info', params: { id : movie.id}}">
                            <img v-lazy="{
                                src: media +'covers/' + movie.image,
                                loading: preloaderImage,
                                error: preloaderImage,
                            }" width="178" height="272" :alt="movie.title">
                        </router-link>
                    </div>
                </li>
            </ul>
        </div>
        <!-- /Section content -->
    </section>
</template>

<script>
    import { hideCaptions } from '../outer-js'
    import image from "../assets/images/preloader178x272.png"

    export default {
        name: "HomeMovies",
        props:['meta', 'items', 'slides','bgimg'],
        data(){
            return {
                slideItems: this.slides,
                preloader: false,
                media: process.env.VUE_APP_MEDIA,
                swiperOption:{
                    centeredSlides: true,
                    autoHeight: true,
                    slidesPerView: 1,
                    spaceBetween: 32,
                    lazy: true,
                    loadOnTransitionStart: true,
                    loadPrevNextAmount: 3,
                    loadPrevNext: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                preloaderImage: image,
            }
        },
        computed:{
            mySwiper(){
                return this.$refs.homePageSwiper.swiper
            },
        },
        mounted(){
            hideCaptions();
            let img = window.document.querySelector('.preloader-desktop');
            if( screen.width < 600 ) {
                img = window.document.querySelector('.preloader-mobile');
            }
            img.addEventListener("load", (e) => {
                console.log(e);
                this.preloader = true;
            } );
            if (img.complete) {
                this.preloader = true;
            }
            this.$nextTick(() => {
                window.dispatchEvent(new Event('resize'));
                this.mySwiper.lazy.loadInSlide(1);
            });
        },
        methods:{
            slideEvent(){
                this.mySwiper.lazy.loadInSlide(+(this.mySwiper.activeIndex) + 1 );
            },
        },
    }
</script>
<style scoped>
</style>
